import { render } from "./Index.vue?vue&type=template&id=6ec2af5c"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Vendors/Users/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ec2af5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ec2af5c', __exports__)) {
    api.reload('6ec2af5c', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=6ec2af5c", () => {
    api.rerender('6ec2af5c', render)
  })

}


export default __exports__